import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_ade_sr_web_genius_sorting",
  stages: {},
  defaultStage: 1,
  goals: {
    booked_with_deals_sorting: 2,
    sr_offer_position_1_click: 3,
    sr_offer_position_2_to_5_click: 4
  }
});

export default utils;
